<section id="pageCover" class="row">
    <img src="../../../assets/images/contactCover.png" alt="" class="pageCover">
    <!--<div class="row pageTitle">Projects</div>-->
    <div class="row pageBreadcrumbs">
        <!--<ol class="breadcrumb">
            <li><a href="index.html">home</a></li>
            <li class="active">Projects</li>
        </ol>-->
    </div>
</section>

<section id="latestPosts" class="row">
    <div class="container">
        <div class="row sectionTitles">
            <h2 class="sectionTitle">{{'Staff' | translate}}</h2>
        </div>
        <div class="row">

            <div class="col-lg-3 blog">
                <div class="row m0 blogInner">
                    <div class="row m0 featureImg">
                        <a>
                            <img src="../../../assets/images/team/7.png" alt="Faceted Search Has Landed"
                                class="img-responsive">
                        </a>
                    </div>
                    <div class="row m0 postExcerpts">
                        <div class="row m0 postExcerptInner">
                            <a  class="postTitle row m0">
                                <h4>{{'Saad' | translate}}</h4>
                            </a>
                            <p>BEng, MSc, PhD, PMO</p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-3 blog">
                <div class="row m0 blogInner">
                    <div class="row m0 featureImg">
                        <a >
                            <img src="../../../assets/images/team/8.png" alt="Faceted Search Has Landed"
                                class="img-responsive">
                        </a>
                    </div>
                    <div class="row m0 postExcerpts">
                        <div class="row m0 postExcerptInner">
                            <a  class="postTitle row m0">
                                <h4>{{'Yasser' | translate}}</h4>
                            </a>
                            <p>{{'YasserTitle' | translate}}</p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-3 blog">
                <div class="row m0 blogInner">
                    <div class="row m0 featureImg">
                        <a >
                            <img src="../../../assets/images/team/9.png" alt="Faceted Search Has Landed"
                                class="img-responsive">
                        </a>
                    </div>
                    <div class="row m0 postExcerpts">
                        <div class="row m0 postExcerptInner">
                            <a  class="postTitle row m0">
                                <h4>{{'Tarek' | translate}}</h4>
                            </a>
                            <p>{{'TarekTitle' | translate}}</p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-3 blog">
                <div class="row m0 blogInner">
                    <div class="row m0 featureImg">
                        <a>
                            <img src="../../../assets/images/team/4.png" alt="Team"
                                class="img-responsive">
                        </a>
                    </div>
                    <div class="row m0 postExcerpts">
                        <div class="row m0 postExcerptInner">
                            <a  class="postTitle row m0">
                                <h4>{{'Mohamed' | translate}}</h4>
                            </a>
                            <p>PMO Consultant, PFMP, PgMP, PMP, PMI-RMP</p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-3 blog">
                <div class="row m0 blogInner">
                    <div class="row m0 featureImg">
                        <a >
                            <img src="../../../assets/images/team/6.png" alt="Faceted Search Has Landed"
                                class="img-responsive">
                        </a>
                    </div>
                    <div class="row m0 postExcerpts">
                        <div class="row m0 postExcerptInner">
                            <a  class="postTitle row m0">
                                <h4>{{'Abdullah' | translate}}</h4>
                            </a>
                            <p>{{'AbdullahTitle' | translate}}</p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-3 blog">
                <div class="row m0 blogInner">
                    <div class="row m0 featureImg">
                        <a >
                            <img src="../../../assets/images/team/3.png" alt="Faceted Search Has Landed"
                                class="img-responsive">
                        </a>
                    </div>
                    <div class="row m0 postExcerpts">
                        <div class="row m0 postExcerptInner">
                            <a  class="postTitle row m0">
                                <h4>{{'Moheeb' | translate}}</h4>
                            </a>
                            <p>{{'MoheebTitle' | translate}}</p>
                        </div>
                    </div>
                </div>
            </div>


            <div class="col-lg-3 blog">
                <div class="row m0 blogInner">
                    <div class="row m0 featureImg">
                        <a routerLink="/team-member">
                            <img src="../../../assets/images/team/1.png" alt="Team"
                                class="img-responsive">
                        </a>
                    </div>
                    <div class="row m0 postExcerpts">
                        <div class="row m0 postExcerptInner">
                            <a  class="postTitle row m0">
                                <h4>{{'Zaher' | translate}} </h4>
                            </a>
                            <p><strong>{{'ZaherTitle' | translate}}</strong> - {{'ZaherTitle2' | translate}}</p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-3 blog">
                <div class="row m0 blogInner">
                    <div class="row m0 featureImg">
                        <a routerLink="/team-member2">
                            <img src="../../../assets/images/team/2.png" alt="Team"
                                class="img-responsive">
                        </a>
                    </div>
                    <div class="row m0 postExcerpts">
                        <div class="row m0 postExcerptInner">
                            <a  class="postTitle row m0">
                                <h4>{{'Wanli' | translate}} </h4>
                            </a>
                            <p><strong>{{'WanliTitle' | translate}}</strong> - {{'WanliTitle2' | translate}}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">

            <div class="col-lg-3 blog">
                <div class="row m0 blogInner">
                    <div class="row m0 featureImg">
                        <a >
                            <img src="../../../assets/images/team/10.png" alt="Faceted Search Has Landed"
                                class="img-responsive">
                        </a>
                    </div>
                    <div class="row m0 postExcerpts">
                        <div class="row m0 postExcerptInner">
                            <a  class="postTitle row m0">
                                <h4>{{'Read' | translate}}</h4>
                            </a>
                            <p>{{'ReadTitle' | translate}}</p>
                        </div>
                    </div>
                </div>
            </div>


            <div class="col-lg-3 blog">
                <div class="row m0 blogInner">
                    <div class="row m0 featureImg">
                        <a>
                            <img src="../../../assets/images/team/5.png" alt="Team"
                                class="img-responsive">
                        </a>
                    </div>
                    <div class="row m0 postExcerpts">
                        <div class="row m0 postExcerptInner">
                            <a  class="postTitle row m0">
                                <h4>{{'Alshehri' | translate}} </h4>
                            </a>
                            <p>{{'AlshehriTitle' | translate}}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
